import DesignerQueueModule from './DesignerQueueModule'
export default DesignerQueueModule
